import { Flex, Text, Icon, IconButton, Box } from "@chakra-ui/react";
import { DeleteIcon } from "@chakra-ui/icons";
import EditIcon from "@root/assets/icons/pencil";
import { useTranslation } from "react-i18next";

interface EntityListItemProps {
  id: string | number;
  name: string;
  icon: React.ElementType;
  onItemClick: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  showActions?: boolean;
}

export const EntityListItem: React.FC<EntityListItemProps> = ({
  id,
  name,
  icon,
  onItemClick,
  onEdit,
  onDelete,
  showActions = true,
}) => {
  const { t } = useTranslation("common");
  return (
    <Flex
      key={id}
      align="center"
      p={2}
      borderRadius="md"
      borderWidth="1px"
      borderColor="gray.100"
      _hover={{ bg: "gray.50", cursor: "pointer" }}
      onClick={onItemClick}
      role="group"
    >
      <Icon as={icon} boxSize={4} mr={1.5} />
      <Text flex="1" fontSize="sm">
        {name}
      </Text>

      {showActions && (onEdit || onDelete) && (
        <Flex gap={1} opacity={0} _groupHover={{ opacity: 1 }}>
          {onEdit && (
            <IconButton
              aria-label={t("projects.edit")}
              icon={<EditIcon />}
              size="xs"
              variant="ghost"
              onClick={(e) => {
                e.stopPropagation();
                onEdit();
              }}
            />
          )}
          {onDelete && (
            <IconButton
              aria-label={t("projects.delete")}
              icon={<DeleteIcon />}
              size="xs"
              variant="ghost"
              onClick={(e) => {
                e.stopPropagation();
                onDelete();
              }}
            />
          )}
        </Flex>
      )}
    </Flex>
  );
};
